import Emoji from '_lib/emoji'

export function handleEmoji (container, link) {
  const emoji = new Emoji()
  let html = container.innerHTML.replace(/on(error|load)=/gi, '').replace(/alert\(.*?\)/gi, '').replace(/javascript:/gi, '')
  html = emoji.replaceEmoji(html)
  html = emoji.replaceEmojiByName(html)
  container.innerHTML = html
}